import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function duiNitRenderer({ value, isOldValue }: RenderProps) {
  const duiNITValue = value as { type: string; value: string } | undefined;
  if (!duiNITValue?.value) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  const label =
    duiNITValue.type === "passport"
      ? "PASAPORTE"
      : duiNITValue.type.toUpperCase();
  return (
    <ValueDisplay isOldValue={isOldValue}>
      ({label})&nbsp;{duiNITValue.value}
    </ValueDisplay>
  );
}
